module.exports = __webpack_public_path__ + "static/img/jk.5a3c30d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/jk.jpg
// module id = bNMa
// module chunks = 7